import React from "react";

const SettingsView = () => {
  return <div>SettingsView</div>;
};

export default SettingsView;
